import React from "react";
import Fire from "../config/Fire";
import { Link } from 'react-router-dom'
import Aux from "./AuxFunctions";
import Colors from "./Colors";

class RenderComment extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      comment: {},
      user: {}
    }
  }

  componentDidMount() {
    try {
      this.setState({ comment: this.props.comment })
      this.getUserInfo();
    } catch (error) {
      Aux.handleError(error)
    }
  }

  getUserInfo = async () => {
    try {
      const user = await Fire.shared.getUserInfoUid(this.props.comment.uid)
      if (user) {
        this.setState({ user: user })
      }
    } catch (error) {
      Aux.handleError(error)
    }
  }



  render() {
    return (
      <div style={{ backgroundColor: "white", padding: "15px 20px", }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent:"space-between", alignItems: "center" }}>
          <div style={{display:"flex"}}>
          <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: 10 }}>
              {Aux.showAvatar(40, this.state.user.avatar, this.state.user.username || "Unknown")}
              {/*               <img src={this.state.user.avatar ? this.state.user.avatar: Aux.TemporaryImage} alt="avatar"
                style={{width:40, height:50, alignSelf: "center", borderRadius:25, margin:10, marginRight:20, objectFit:"cover"}}
              /> */}

            </div>
          </Link>
          <div style={{ display: "flex", flexDirection: "column", justifyContent:"center", }}>
            <Link to={`/user/${this.state.user.username}`} style={{ textDecoration: "none" }} className="text-hover">
              <span style={{ alignSelft: "center", color: Colors.darkText, fontWeight: "bold", overflowWrap: "anywhere" }}>{this.state.user.username || "Unknown"}</span>
            </Link>
            <div style={{ display: "flex", justifyContent: "flex-start", margin: 0 }}>
              {this.state.comment.text ?
                <span style={{ margin: 0, marginTop: 5 }}>{this.state.comment.text || ""}</span>
                : null
              }
            </div>
          </div>
          </div>
          <h3 style={{ marginRight: 10, marginLeft:10 }}>{this.state.comment.coins || 0}$</h3>
        </div>

      </div>
    );
  }
}

export default RenderComment;